import { ApiProperty } from "@nestjs/swagger";

export class ShipmentStatusRequest{
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    masterBrandId?:number;
    @ApiProperty()
    selectedLoadingFromDate?:any;
    @ApiProperty()
    selectedLoadingToDate?:any;
}